import {Component, Input} from '@angular/core';
import {ClockInReportItemEntryDto} from '../../../../../Models/Reports/Rrhh/clock-in-report.interface';

@Component({
  selector: 'app-clock-in-detail-report-item',
  templateUrl: './clock-in-detail-report-item.component.html',
  styleUrls: ['./clock-in-detail-report-item.component.scss'],
  standalone: false,
})
export class ClockInDetailReportItemComponent {
  @Input() item!: ClockInReportItemEntryDto;
}
